module.exports = __webpack_public_path__ + "static/media/piped_gas.2655841a.svg";